export const flags = {
    useRsvpSessionStorage: true,
};
